import { ArrowUp, ArrowDown, ArrowMid } from 'cc/Logo'
import { cn } from 'common/utils'

export const VoteEmote = ({ vote, className }) => {
  const Component = vote > 0 ? ArrowUp : vote < 0 ? ArrowDown : ArrowMid
  return <Component className={className || 'w-8'} />
}

export default VoteEmote
